export default __webpack_public_path__ + "static/media/North.23cc0698.png";